import React from 'react';
import Slider from 'react-slick';
import './RecruitersSection.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const recruiters = [
  { name: 'EMIIT', logo: require('../../Assets/recruiters/emiit.jpeg') },
  { name: 'Tata Consultancy Services', logo: require('../../Assets/recruiters/TCS.jpeg') },
  { name: 'Wipro', logo: require('../../Assets/recruiters/wipro.jpeg') },
  { name: 'Deloitte', logo: require('../../Assets/recruiters/Delotte.jpeg') },
  { name: 'HDFC Bank', logo: require('../../Assets/recruiters/HDFCbank.jpeg') },
  { name: 'Tech Mahindra', logo: require('../../Assets/recruiters/techmahindra.jpeg') },
  { name: 'Capgemini', logo: require('../../Assets/recruiters/capgemini.jpeg') },
  { name: 'Axis Bank', logo: require('../../Assets/recruiters/Axisbank.jpeg') },
  { name: 'Vibrant Infocom', logo: require('../../Assets/recruiters/vibrant.jpeg') },
  { name: 'Bandhan Bank', logo: require('../../Assets/recruiters/bandhan-bank.jpeg') },
  { name: 'Santra Publication', logo: require('../../Assets/recruiters/santra.jpeg') },
  { name: 'Graphics Art', logo: require('../../Assets/recruiters/graphics-Art.jpeg') },
];

const sliderSettings = {
  autoplay: true,
  autoplaySpeed: 2400,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: true,
  arrows: false,
  dots: true,
  pauseOnHover: true,
  pauseOnFocus: true,
  accessibility: true,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 4 } },
    { breakpoint: 900, settings: { slidesToShow: 3 } },
    { breakpoint: 640, settings: { slidesToShow: 2 } },
    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

export default function RecruitersSection() {
  return (
    <section className="recruiters-section" aria-labelledby="recruiters-title">
      <div className="recruiters-section__inner">
        <div className="recruiters-section__heading">
          <span className="recruiters-section__eyebrow">CAREER PARTNERS</span>
          <h2 id="recruiters-title">Our Recruiters</h2>
          <p>Organizations where our students build skills and careers.</p>
        </div>

        <Slider className="recruiters-slider" {...sliderSettings}>
          {recruiters.map(({ name, logo }) => (
            <div className="recruiters-slider__slide" key={name}>
              <div className="recruiters-slider__card">
                <img
                  className={name === 'Tech Mahindra' || name === 'Axis Bank' ? 'recruiters-slider__logo recruiters-slider__logo--checkerboard' : 'recruiters-slider__logo'}
                  src={logo}
                  alt={`${name} logo`}
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
